import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import "./AboutUs.css";
import companyBg from "../../assets/companyBg.jpg";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Company from "../../assets/Company.jpg";
import Company2 from "../../assets/Company2.jpg";
import Company3 from "../../assets/Company3.jpg";
import Company4 from "../../assets/Company4.jpg";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import Yj from "../../assets/Yjpoly.png";
import retail from "../../assets/retail.png";
import health from "../../assets/health.png";
import construct from "../../assets/Construction.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";



export default function AboutUs() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const values = [
    { icon: "👥", title: "Collaboration", desc: "We believe in teamwork – with our clients and within our organization – to achieve shared success." },
    { icon: "🎯", title: "Innovation", desc: "Our mission is to constantly improve and push boundaries, delivering ERP that adapts to the future." },
    { icon: "🌱", title: "Sustainability", desc: "Like the larch tree, we are rooted in strength and resilience, creating sustainable digital ecosystems." },
  ];

const stories = [
  {
    name: "Yj Polytech",
    story: "With Larch ERP, we've achieved improved inventory management through real-time tracking, enhanced stock monitoring, and efficient handling of multiple parts. We've also implemented FIFO management, ensured traceability for quality control, and reduced the workload associated with manual stock checks. Overall, Larch ERP has streamlined our inventory processes, enabling better decision-making and more efficient operations.",
    // person: "Rex Martin",
    position: "Sales Department",
    // logo: Yj,        
    bgImage: Company,         
  },
  {
    name: "RetailX",
    story: "RetailX integrated all their POS systems with Larch ERP. Inventory management became seamless, enabling rapid expansion without adding extra staff.",
    // person: "Jane Smith",
    position: "Operations Head",
    // logo:  Yj,
    bgImage: Company2,
  },
  {
    name: "MediCare Hospital",
    story: "With Larch ERP, MediCare Hospital automated patient billing, staff scheduling, and reporting. This freed hundreds of hours monthly and increased patient satisfaction.",
    // person: "Dr. Alex Brown",
    position: "Hospital Director",
    // logo:  Yj,
    bgImage: Company3,
  },
  {
    name: "EduSmart Academy",
    story: "EduSmart Academy replaced multiple legacy systems with Larch ERP. Student data, exam schedules, and teacher reports are now fully automated and easy to access.",
    // person: "Emily Clark",
    position: "Principal",
    // logo:  Yj,
    bgImage: Company4,
  },
];


  const sliderRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const card = slider.querySelector(".success-card");
    if (!card) return;

    const cardWidth = card.offsetWidth + 32; // card width + gap
    const totalCards = stories.length;
    let index = 0;

    const startAutoScroll = () => {
      intervalRef.current = setInterval(() => {
        index++;
        if (index >= totalCards) index = 0;
        slider.scrollTo({ left: cardWidth * index, behavior: "smooth" });
      }, 4000); // change this number to tweak timing
    };

    startAutoScroll();

    slider.addEventListener("mouseenter", () => clearInterval(intervalRef.current));
    slider.addEventListener("mouseleave", startAutoScroll);

    return () => {
      clearInterval(intervalRef.current);
      slider.removeEventListener("mouseenter", () => clearInterval(intervalRef.current));
      slider.removeEventListener("mouseleave", startAutoScroll);
    };
  }, [stories]);

  return (
    <div className="aboutus-containers">
      <Header />

      {/* Hero Section */}
      <section className="aboutus-hero-section">
        <motion.div
          className="hero-bg"
          style={{ backgroundImage: `url(${companyBg})` }}
          initial={{ scale: 1 }}
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
        />
        <div className="aboutus-hero-content">
          <motion.h1 initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
            BUILD SMARTER! <span className="highlight">GROW FASTER!</span>
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.2 }}>
            Building the future of ERP with innovation rooted in nature – just like the strength of a larch forest.
          </motion.p>
        </div>
      </section>

      {/* Company Statement */}
      <section className="company-section">
        <motion.h2 className="company-heading" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          About Us 
        </motion.h2>
        <motion.p className="company-description" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}>
          We at Larch Technologies Company offer cost-effective, customized, high-quality Enterprise Resource Planning
          (ERP) application development solutions for small and medium businesses. We provide strategic design services
          that enable our clients to increase sales, build brand awareness, and strengthen customer reliability.
          To best understand your business, we follow an incremental process of intake, research, innovation, and validation.
          We are proud to have the services of a large number of experienced development and management professionals working across process management solutions.
        </motion.p>
      </section>

      {/* Who We Are / Values */}
      <section className="values-section">
        <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          Who We Are
        </motion.h2>
        <div className="values-grid">
          {values.map((item, i) => (
            <motion.div key={i} className="value-card" initial={{ opacity: 0, y: 50, scale: 0.9 }} whileInView={{ opacity: 1, y: 0, scale: 1 }} whileHover={{ scale: 1.05 }} transition={{ duration: 0.7, delay: i * 0.1 }}>
              <div className="value-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>
       {/* Portfolio Section */}
{/* Portfolio Section */}
<section className="values-section">
  <motion.h2
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
  >
    Portfolio
  </motion.h2>
  <div className="portfolio-wrapper">
    <button
      className="scroll-btn left"
      onClick={() => {
        document.querySelector(".portfolio-cards").scrollBy({ left: -300, behavior: "smooth" });
      }}
    >
      ‹
    </button>
    <div className="portfolio-cards">
      {[
        { title: "ERP for Manufacturing", desc: "Optimized workflows for a mid-sized factory.", bgImage:Company },
        { title: "Retail ERP Suite", desc: "Seamless POS + inventory integration.", bgImage:retail },
        { title: "ERP for Rubber Products", desc: "Patient, billing & staff modules combined.", bgImage:health },
        { title: "ERP for Injection Molding", desc: "Student, course & exam management system.", bgImage: retail },
        { title: "ERP for Wirring Harness", desc: "Project tracking with vendor management.", bgImage: construct },
        { title: "ERP for Cable Assembly", desc: "Fleet & shipment tracking simplified.", bgImage: retail},
      ].map((item, i) => (
       <motion.div
  key={i}
  className="portfolio-card text-card"
  style={{
    backgroundImage: `url(${item.bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    color: "#fff",
    overflow: "hidden",       // keep image inside card
    borderRadius: "12px",     // match your existing card rounding
  }}
  initial={{ opacity: 0, y: 50, scale: 0.9 }}
  whileInView={{ opacity: 1, y: 0, scale: 1 }}
  whileHover={{ scale: 1.05 }}
  transition={{ duration: 0.6, delay: i * 0.1 }}
>
  {/* Overlay */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      borderRadius: "inherit", // make overlay respect card shape
    }}
  />

  {/* Text content */}
  <div style={{ position: "relative", zIndex: 2 }}>
    <h3>{item.title}</h3>
    <p>{item.desc}</p>
  </div>
</motion.div>

      ))}
    </div>
    <button
      className="scroll-btn right"
      onClick={() => {
        document.querySelector(".portfolio-cards").scrollBy({ left: 300, behavior: "smooth" });
      }}
    >
      ›
    </button>
  </div>
</section>




     
{/* Success Stories Section */}
{/* Success Stories Section */}
<section className="success-section">
  <motion.h2
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
  >
    Success Stories
  </motion.h2>

  <div className="success-slider-wrapper">
    {/* Left Arrow */}
    <button
      className="scroll-btn left"
      onClick={() => {
        sliderRef.current.scrollBy({ left: -700, behavior: "smooth" });
      }}
    >
      ‹
    </button>

    {/* Scrollable Cards */}
    <div className="success-slider-scrollable" ref={sliderRef}>
      {stories.map((item, i) => (
        <div
          key={i}
          className="success-card full-card"
          style={{
            backgroundImage: `url(${item.bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            color: "#fff",
            overflow: "hidden",
            borderRadius: "12px",
            height: "600px",
            flex: "0 0 auto",
          }}
        >
          {/* Dark overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0,0,0,0.55)",
              borderRadius: "inherit",
              zIndex: 1,
            }}
          />

          {/* Content */}
          <div style={{ position: "relative", zIndex: 2 }}>
            {/* <img
              src={item.logo}
              alt={`${item.name} logo`}
              style={{ width: "60px", height: "auto", marginBottom: "10px" }}
            /> */}

            <h3 style={{ textShadow: "2px 2px 6px rgba(0,0,0,0.8)" }}>{item.name}</h3>
            <p
              style={{
                fontStyle: "italic",
                textShadow: "2px 2px 6px rgba(0,0,0,0.8)",
              }}
            >
              “{item.story}”
            </p>

            <p
              style={{
                fontWeight: "600",
                marginTop: "8px",
                textShadow: "1px 1px 4px rgba(0,0,0,0.7)",
              }}
            >
              {item.person}
            </p>
            <p
              style={{
                fontSize: "0.9em",
                opacity: 0.9,
                textShadow: "1px 1px 3px rgba(0,0,0,0.7)",
              }}
            >
              {item.position}
            </p>
          </div>
        </div>
      ))}
    </div>

    {/* Right Arrow */}
    <button
      className="scroll-btn right"
      onClick={() => {
        sliderRef.current.scrollBy({ left: 700, behavior: "smooth" });
      }}
    >
      ›
    </button>
  </div>
</section>


      {/* Call to Action */}
      <section className="cta-section">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <h2>Let’s Grow Together</h2>
          <p>Partner with us to transform your business with intelligent, scalable, and future-ready ERP solutions.</p>
           <Link to="/Contactus"></Link>
          <button className="cta-button" onClick={() => navigate("/Contactus")}>
          Contact Us
        </button>
        </motion.div>
      </section>

      <Footer />
        <ERPChatbot />
    </div>
  );
}
